"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TroveWithPendingRedistribution = exports.UserTrove = exports._emptyTrove = exports.Trove = exports._normalizeTroveWithdrawCollUnleverUp = exports._normalizeTroveAddCollLeverUp = exports._normalizeTroveAdjustment = exports._normalizeTroveLeverUpCreation = exports._normalizeTroveCreation = void 0;
const assert_1 = __importDefault(require("assert"));
const Decimal_1 = require("./Decimal");
// import { decimalify, numberify, panic } from "./_utils";
const constants_1 = require("./constants");
const invalidTroveCreation = (invalidTrove, error) => ({
    type: "invalidCreation",
    invalidTrove,
    error
});
const troveCreation = (params) => ({
    type: "creation",
    params
});
const troveCreationLeverUp = (params) => ({
    type: "creationLeverUp",
    params
});
const troveClosure = (params) => ({
    type: "closure",
    params
});
const troveClosureLeverUp = (params) => ({
    type: "closureUnleverUp",
    params
});
const troveAdjustment = (params, setToZero) => ({
    type: "adjustment",
    params,
    setToZero
});
const troveAddCollLeverUp = (params) => ({
    type: "addCollLeverUp",
    params
});
const troveWithdrawCollUnleverUp = (params) => ({
    type: "withdrawCollUnleverUp",
    params
});
const valueIsDefined = (entry) => entry[1] !== undefined;
const allowedTroveCreationKeys = [
    "decimals",
    "depositCollaterals",
    "borrowYUSD"
];
const allowedTroveCreationLeverUpKeys = [
    "decimals",
    "depositCollaterals",
    "depositCollateralsLeverages",
    "depositCollateralsMaxSlippages",
    "borrowYUSD",
];
function checkAllowedTroveCreationKeys(entries) {
    const badKeys = entries
        .filter(([k]) => !allowedTroveCreationKeys.includes(k))
        .map(([k]) => `'${k}'`);
    if (badKeys.length > 0) {
        throw new Error(`TroveCreationParams: property ${badKeys.join(", ")} not allowed`);
    }
}
function checkAllowedTroveCreationLeverUpKeys(entries) {
    const badKeys = entries
        .filter(([k]) => !allowedTroveCreationLeverUpKeys.includes(k))
        .map(([k]) => `'${k}'`);
    if (badKeys.length > 0) {
        throw new Error(`TroveCreationLeverUpParams: property ${badKeys.join(", ")} not allowed`);
    }
}
const troveCreationParamsFromEntries = (entries) => {
    const params = Object.fromEntries(entries);
    const missingKeys = allowedTroveCreationKeys.filter(k => !(k in params)).map(k => `'${k}'`);
    if (missingKeys.length > 0) {
        throw new Error(`TroveCreationParams: property ${missingKeys.join(", ")} missing`);
    }
    return params;
};
const troveCreationLeverUpParamsFromEntries = (entries) => {
    const params = Object.fromEntries(entries);
    const missingKeys = allowedTroveCreationKeys.filter(k => !(k in params)).map(k => `'${k}'`);
    if (missingKeys.length > 0) {
        throw new Error(`TroveCreationParams: property ${missingKeys.join(", ")} missing`);
    }
    return params;
};
const decimalize = ([k, v]) => [k, Decimal_1.Decimal.from(v)];
const nonZero = ([, v]) => !v.isZero;
/** @internal */
const _normalizeTroveCreation = (params) => {
    const definedEntries = Object.entries(params).filter(valueIsDefined);
    checkAllowedTroveCreationKeys(definedEntries);
    // check if we need to check for nonzero entries
    //const nonZeroEntries = definedEntries.map(decimalize);
    return troveCreationParamsFromEntries(definedEntries);
};
exports._normalizeTroveCreation = _normalizeTroveCreation;
const _normalizeTroveLeverUpCreation = (params) => {
    const definedEntries = Object.entries(params).filter(valueIsDefined);
    checkAllowedTroveCreationLeverUpKeys(definedEntries);
    // check if we need to check for nonzero entries
    //const nonZeroEntries = definedEntries.map(decimalize);
    return troveCreationLeverUpParamsFromEntries(definedEntries);
};
exports._normalizeTroveLeverUpCreation = _normalizeTroveLeverUpCreation;
const allowedTroveAdjustmentKeys = [
    "depositCollaterals",
    "withdrawCollaterals",
    "borrowYUSD",
    "repayYUSD",
];
const allowedTroveAddCollLeverUpKeys = [
    "depositCollaterals",
    "depositCollateralsLeverages",
    "depositCollateralsMaxSlippages",
    "borrowYUSD"
];
const allowedTroveWithdrawCollUnleverUpKeys = [
    "withdrawCollaterals",
    "withdrawCollateralsMaxSlippages",
    "repayYUSD"
];
function checkAllowedTroveAdjustmentKeys(entries) {
    const badKeys = entries
        .filter(([k]) => !allowedTroveAdjustmentKeys.includes(k))
        .map(([k]) => `'${k}'`);
    if (badKeys.length > 0) {
        throw new Error(`TroveAdjustmentParams: property ${badKeys.join(", ")} not allowed`);
    }
}
function checkAllowedTroveAddCollLeverUpKeys(entries) {
    const badKeys = entries
        .filter(([k]) => !allowedTroveAddCollLeverUpKeys.includes(k))
        .map(([k]) => `'${k}'`);
    if (badKeys.length > 0) {
        throw new Error(`TroveAddCollLeverUpKParams: property ${badKeys.join(", ")} not allowed`);
    }
}
function checkAllowedTroveWithdrawalCollUnleverUpKeys(entries) {
    const badKeys = entries
        .filter(([k]) => !allowedTroveWithdrawCollUnleverUpKeys.includes(k))
        .map(([k]) => `'${k}'`);
    if (badKeys.length > 0) {
        throw new Error(`TroveWithdrawCollUnleverUpParams: property ${badKeys.join(", ")} not allowed`);
    }
}
const collateralChangeFrom = ({ depositCollaterals, withdrawCollaterals }) => {
    if (depositCollaterals !== undefined && withdrawCollaterals !== undefined) {
        return { depositCollaterals, withdrawCollaterals };
    }
    if (depositCollaterals !== undefined) {
        return { depositCollaterals };
    }
    if (withdrawCollaterals !== undefined) {
        return { withdrawCollaterals };
    }
};
const debtChangeFrom = ({ borrowYUSD, repayYUSD }) => {
    if (borrowYUSD !== undefined && repayYUSD !== undefined) {
        throw new Error("TroveAdjustmentParams: 'borrowYUSD' and 'repayYUSD' can't be present at the same time");
    }
    if (borrowYUSD !== undefined) {
        return { borrowYUSD };
    }
    if (repayYUSD !== undefined) {
        return { repayYUSD };
    }
};
const troveAdjustmentParamsFromEntries = (entries) => {
    const params = Object.fromEntries(entries);
    const collateralChange = collateralChangeFrom(params);
    const debtChange = debtChangeFrom(params);
    if (collateralChange !== undefined && debtChange !== undefined) {
        return { ...collateralChange, ...debtChange };
    }
    if (collateralChange !== undefined) {
        return collateralChange;
    }
    if (debtChange !== undefined) {
        return debtChange;
    }
    throw new Error("TroveAdjustmentParams: must include at least one non-zero parameter");
};
/** @internal */
const _normalizeTroveAdjustment = (params) => {
    const definedEntries = Object.entries(params).filter(valueIsDefined);
    checkAllowedTroveAdjustmentKeys(definedEntries);
    //check for non zero entries
    //const nonZeroEntries = definedEntries.map(decimalize).filter(nonZero);
    return troveAdjustmentParamsFromEntries(definedEntries);
};
exports._normalizeTroveAdjustment = _normalizeTroveAdjustment;
const collateralLeverUpFrom = ({ depositCollaterals, depositCollateralsLeverages, depositCollateralsMaxSlippages }) => {
    if (depositCollaterals !== undefined && depositCollateralsLeverages !== undefined && depositCollateralsMaxSlippages !== undefined) {
        return { depositCollaterals, depositCollateralsLeverages, depositCollateralsMaxSlippages };
    }
};
const troveAddCollLeverUpParamsFromEntries = (entries) => {
    const params = Object.fromEntries(entries);
    const missingKeys = allowedTroveAddCollLeverUpKeys.filter(k => !(k in params)).map(k => `'${k}'`);
    if (missingKeys.length > 1 && missingKeys[0] != "borrowYUSD") {
        throw new Error(`TroveAddCollLeverupParams: property ${missingKeys.join(", ")} missing`);
    }
    const collateralLeverup = collateralLeverUpFrom(params);
    const { borrowYUSD } = params;
    if (collateralLeverup !== undefined && borrowYUSD !== undefined) {
        return { ...collateralLeverup, borrowYUSD };
    }
    if (collateralLeverup !== undefined) {
        return collateralLeverup;
    }
    throw new Error("TroveAddCollLeverUpParams: must include at least one non-zero parameter");
};
const _normalizeTroveAddCollLeverUp = (params) => {
    const definedEntries = Object.entries(params).filter(valueIsDefined);
    checkAllowedTroveAddCollLeverUpKeys(definedEntries);
    // check if we need to check for nonzero entries
    //const nonZeroEntries = definedEntries.map(decimalize);
    return troveAddCollLeverUpParamsFromEntries(definedEntries);
};
exports._normalizeTroveAddCollLeverUp = _normalizeTroveAddCollLeverUp;
const collateralUnleverUpFrom = ({ withdrawCollaterals, withdrawCollateralsMaxSlippages }) => {
    if (withdrawCollaterals !== undefined && withdrawCollateralsMaxSlippages !== undefined) {
        return { withdrawCollaterals, withdrawCollateralsMaxSlippages };
    }
};
const troveWithdrawCollUnleverUpParamsFromEntries = (entries) => {
    const params = Object.fromEntries(entries);
    const missingKeys = allowedTroveWithdrawCollUnleverUpKeys.filter(k => !(k in params)).map(k => `'${k}'`);
    if (missingKeys.length > 1 && missingKeys[0] != "repayYUSD") {
        throw new Error(`TroveWithdrawCollUnleverupParams: property ${missingKeys.join(", ")} missing`);
    }
    const collateralUnleverup = collateralUnleverUpFrom(params);
    const { repayYUSD } = params;
    if (collateralUnleverup !== undefined && repayYUSD !== undefined) {
        return { ...collateralUnleverup, repayYUSD };
    }
    if (collateralUnleverup !== undefined) {
        return collateralUnleverup;
    }
    throw new Error("TroveAddCollLeverUpParams: must include at least one non-zero parameter");
};
const _normalizeTroveWithdrawCollUnleverUp = (params) => {
    const definedEntries = Object.entries(params).filter(valueIsDefined);
    checkAllowedTroveWithdrawalCollUnleverUpKeys(definedEntries);
    // check if we need to check for nonzero entries
    //const nonZeroEntries = definedEntries.map(decimalize);
    return troveWithdrawCollUnleverUpParamsFromEntries(definedEntries);
};
exports._normalizeTroveWithdrawCollUnleverUp = _normalizeTroveWithdrawCollUnleverUp;
const applyFee = (borrowingRate, debtIncrease) => Decimal_1.Decimal.ONE.add(borrowingRate).mul(debtIncrease);
const unapplyFee = (borrowingRate, debtIncrease) => debtIncrease._divCeil(Decimal_1.Decimal.ONE.add(borrowingRate));
const NOMINAL_COLLATERAL_RATIO_PRECISION = Decimal_1.Decimal.from(100);
function checkNoCollats(x) {
    if (Object.keys(x).length == 0) {
        return x;
    }
}
/**
 * A combination of collateral and debt.
 *
 * @public
 */
class Trove {
    /** @internal */
    constructor(collaterals = {}, decimals = {}, debt = { 'debt': Decimal_1.Decimal.ZERO }) {
        this.decimals = decimals;
        this.collaterals = collaterals;
        this.debt = debt;
    }
    get isEmpty() {
        return (Object.keys(this.collaterals).length === 0) && this.debt['debt'].isZero;
    }
    /**
     * Amount of YUSD that must be repaid to close this Trove.
     *
     * @remarks
     * This doesn't include the liquidation reserve, which is refunded in case of normal closure.
     */
    get netDebt() {
        if (this.debt['debt'].lt(constants_1.YUSD_LIQUIDATION_RESERVE)) {
            throw new Error(`netDebt should not be used when debt < ${constants_1.YUSD_LIQUIDATION_RESERVE}`);
        }
        return this.debt['debt'].sub(constants_1.YUSD_LIQUIDATION_RESERVE);
    }
    /** @internal */
    // come back to this
    // get _nominalCollateralRatio(): Decimal {
    //   let total:Decimal = Decimal.ZERO;
    //   // insert safety ratios hardcoded values array for Decimal.ONE
    //   // console.log('this.collaterals trove', this.collaterals)
    //   if (Object.keys(this.collaterals).length === 0) {
    //     return Decimal.ZERO
    //   }
    //   // console.log("this.collaterals", this.collaterals)
    //   for (const key in this.collaterals) {
    //     //  console.log("key", key)
    //     //  console.log("this.collateralRatio[key]", this.collaterals[key])
    //     //  console.log("safetyRatio[key]", safetyRatio[key])
    //      const usdColl = this.collaterals[key].mul(safetyRatio[key])
    //      total = total.add(usdColl)
    //   }
    //   return total.div(this.debt['debt']);
    // }
    /** Calculate the Trove's collateralization ratio at a given price. */
    // Not make sure price array is set correctly to the corresponding collateral types of the Trove.
    collateralRatio(price, ratios) {
        let total = Decimal_1.Decimal.ZERO;
        //console.log("this.decimals", this.decimals["0x02823f9B469960Bb3b1de0B3746D4b95B7E35543"].toNumber())
        for (const key in this.collaterals) {
            const usdColl = this.collaterals[key].mul(price[key]).mul(ratios[key]).div(10 ** (this.decimals[key].toNumber()));
            total = total.add(usdColl);
        }
        if (total === Decimal_1.Decimal.ZERO) {
            return Decimal_1.Decimal.ZERO;
        }
        else {
            return total.mul(10 ** 18).div(this.debt['debt']);
        }
    }
    /**
     * Whether the Trove is undercollateralized at a given price.
     *
     * @returns
     * `true` if the Trove's collateralization ratio is less than the
     * {@link MINIMUM_COLLATERAL_RATIO}.
     */
    collateralRatioIsBelowMinimum(price, safetyRatios) {
        return this.collateralRatio(price, safetyRatios).lt(constants_1.MINIMUM_COLLATERAL_RATIO);
    }
    /**
     * Whether the collateralization ratio is less than the {@link CRITICAL_COLLATERAL_RATIO} at a
     * given price.
     *
     * @example
     * Can be used to check whether the Liquity protocol is in recovery mode by using it on the return
     * value of {@link ReadableLiquity.getTotal | getTotal()}. For example:
     *
     * ```typescript
     * const total = await liquity.getTotal();
     * const price = await liquity.getPrice();
     *
     * if (total.collateralRatioIsBelowCritical(price)) {
     *   // Recovery mode is active
     * }
     * ```
     */
    collateralRatioIsBelowCritical(price, recoveryRatios) {
        // console.log('price', price)
        return this.collateralRatio(price, recoveryRatios).lt(constants_1.CRITICAL_COLLATERAL_RATIO);
    }
    /** Whether the Trove is sufficiently collateralized to be opened during recovery mode. */
    isOpenableInRecoveryMode(price, recoveryRatios) {
        return this.collateralRatio(price, recoveryRatios).gte(constants_1.CRITICAL_COLLATERAL_RATIO);
    }
    /** @internal */
    // Todo update if needed 
    toString() {
        return `{ collateral: ${this.collaterals}, debt: ${this.debt} }`;
    }
    // CHECK IF STRINGIFY IS OK (if collats are out of order for this vs that)
    equals(that) {
        return JSON.stringify(this.collaterals) == JSON.stringify(that.collaterals);
    }
    partial_eq(that) {
        return JSON.stringify(this.collaterals) == JSON.stringify(that.collaterals);
    }
    add(that) {
        const tempCollateralAmounts = {};
        for (const key in this.collaterals) {
            if (!(key in that.collaterals)) {
                that.collaterals[key] = Decimal_1.Decimal.ZERO;
            }
            tempCollateralAmounts[key] = this.collaterals[key].add(that.collaterals[key]);
        }
        return new Trove(tempCollateralAmounts, this.decimals, { 'debt': this.debt['debt'].add(that.debt['debt']) });
    }
    addCollateral(collaterals) {
        const tempCollateralAmounts = {};
        for (const key in this.collaterals) {
            if (!(key in collaterals)) {
                collaterals[key] = Decimal_1.Decimal.ZERO;
            }
            tempCollateralAmounts[key] = this.collaterals[key].add(collaterals[key]);
        }
        return new Trove(tempCollateralAmounts, this.decimals, this.debt);
    }
    addDebt(debt) {
        return new Trove(this.collaterals, this.decimals, { 'debt': this.debt['debt'].add(debt['debt']) });
    }
    subtract(that) {
        const tempCollateralAmounts = {};
        for (const key in this.collaterals) {
            if (!(key in that.collaterals)) {
                that.collaterals[key] = Decimal_1.Decimal.ZERO;
            }
            tempCollateralAmounts[key] = this.collaterals[key].sub(that.collaterals[key]);
            if (tempCollateralAmounts[key].lt(Decimal_1.Decimal.ZERO)) {
                tempCollateralAmounts[key] = Decimal_1.Decimal.ZERO;
            }
        }
        return new Trove(tempCollateralAmounts, this.decimals, this.debt['debt'].gt(that.debt['debt']) ? { 'debt': this.debt['debt'].sub(that.debt['debt']) } : { 'debt': Decimal_1.Decimal.ZERO });
    }
    subtractCollateral(collaterals) {
        const tempCollateralAmounts = {};
        for (const key in this.collaterals) {
            if (!(key in collaterals)) {
                collaterals[key] = Decimal_1.Decimal.ZERO;
            }
            tempCollateralAmounts[key] = this.collaterals[key].sub(collaterals[key]);
            if (tempCollateralAmounts[key].lt(Decimal_1.Decimal.ZERO)) {
                tempCollateralAmounts[key] = Decimal_1.Decimal.ZERO;
            }
        }
        return new Trove(tempCollateralAmounts, this.decimals, this.debt);
    }
    subtractDebt(debt) {
        return new Trove(this.collaterals, this.decimals, this.debt['debt'].gt(debt['debt']) ? { 'debt': this.debt['debt'].sub(debt['debt']) } : { 'debt': Decimal_1.Decimal.ZERO });
    }
    multiply(multiplier) {
        const tempCollateralAmounts = {};
        // console.log("multiplier", multiplier)
        // console.log("this.collaterals", this.collaterals)
        for (const key in this.collaterals) {
            // console.log("this.collaterals[key]", this.collaterals[key])
            // console.log("multiplier[key]", multiplier[key])
            // console.log("KEY", key)
            tempCollateralAmounts[key] = this.collaterals[key].mul(multiplier[key]);
        }
        return new Trove(tempCollateralAmounts, this.decimals, this.debt);
    }
    // look into this one
    setCollateral(collateral) {
        return new Trove(collateral, this.decimals, this.debt);
    }
    setDebt(debt) {
        return new Trove(this.collaterals, this.decimals, debt);
    }
    _debtChange({ debt }, borrowingRate) {
        return debt['debt'].gt(this.debt['debt'])
            ? { borrowYUSD: { 'debt': unapplyFee(borrowingRate, debt['debt'].sub(this.debt['debt'])) } }
            : { repayYUSD: { 'debt': this.debt['debt'].sub(debt['debt']) } };
    }
    _collateralChange({ collaterals }) {
        const depositCollaterals = {};
        const withdrawCollaterals = {};
        for (const key in collaterals) {
            if (collaterals[key].gt(this.collaterals[key])) {
                depositCollaterals[key] = (collaterals[key].sub(this.collaterals[key]));
            }
            else {
                withdrawCollaterals[key] = (this.collaterals[key].sub(collaterals[key]));
            }
        }
        if (Object.keys(depositCollaterals).length != 0 && Object.keys(withdrawCollaterals).length != 0) {
            return { depositCollaterals: depositCollaterals, withdrawCollaterals: withdrawCollaterals };
        }
        else if (Object.keys(depositCollaterals).length != 0) {
            return { depositCollaterals: depositCollaterals };
        }
        else {
            return { withdrawCollaterals: withdrawCollaterals };
        }
    }
    /**
     * Calculate the difference between this Trove and another.
     *
     * @param that - The other Trove.
     * @param borrowingRate - Borrowing rate to use when calculating a borrowed amount.
     *
     * @returns
     * An object representing the change, or `undefined` if the Troves are equal.
     */
    // Come back to this only used in trove test
    whatChanged(that, borrowingRate = constants_1.MINIMUM_BORROWING_RATE) {
        var _a;
        if (this.equals(that)) {
            return undefined;
        }
        if (this.isEmpty) {
            if (that.debt['debt'].lt(constants_1.YUSD_LIQUIDATION_RESERVE)) {
                return invalidTroveCreation(that, "missingLiquidationReserve");
            }
            return troveCreation({
                decimals: that.decimals,
                depositCollaterals: that.collaterals,
                borrowYUSD: { 'debt': unapplyFee(borrowingRate, that.netDebt) }
            });
        }
        if (that.isEmpty) {
            return troveClosure(this.netDebt.nonZero
                ? { withdrawCollaterals: this.collaterals, repayYUSD: { 'debt': this.netDebt } }
                : { withdrawCollaterals: this.collaterals });
        }
        // figure out that.collateralAmounts.zero
        return this.equals(that)
            ? troveAdjustment(this._debtChange(that, borrowingRate), that.debt['debt'].zero && "debt")
            : this.debt['debt'].eq(that.debt['debt'])
                ? troveAdjustment(this._collateralChange(that), checkNoCollats(that.collaterals) && "collateral")
                : troveAdjustment({
                    ...this._debtChange(that, borrowingRate),
                    ...this._collateralChange(that)
                }, (_a = (that.debt.zero && "debt")) !== null && _a !== void 0 ? _a : (checkNoCollats(that.collaterals) && "collateral"));
    }
    /**
     * Make a new Trove by applying a {@link TroveChange} to this Trove.
     *
     * @param change - The change to apply.
     * @param borrowingRate - Borrowing rate to use when adding a borrowed amount to the Trove's debt.
     */
    apply(change, borrowingRate = constants_1.MINIMUM_BORROWING_RATE) {
        if (!change) {
            return this;
        }
        switch (change.type) {
            case "invalidCreation":
                if (!this.isEmpty) {
                    throw new Error("Can't create onto existing Trove");
                }
                return change.invalidTrove;
            case "creation": {
                if (!this.isEmpty) {
                    throw new Error("Can't create onto existing Trove");
                }
                const { depositCollaterals, borrowYUSD, decimals } = change.params;
                // console.log("borrowYUSD['debt']", borrowYUSD['debt'])
                // console.log("borrowingRate", borrowingRate)
                return new Trove(depositCollaterals, decimals, { 'debt': constants_1.YUSD_LIQUIDATION_RESERVE.add(applyFee(borrowingRate, borrowYUSD['debt'])) });
            }
            case "creationLeverUp": {
                if (!this.isEmpty) {
                    throw new Error("Can't create onto existing Trove");
                }
                const { depositCollaterals, borrowYUSD, decimals } = change.params;
                // console.log("borrowYUSD['debt']", borrowYUSD['debt'])
                // console.log("borrowingRate", borrowingRate)
                return new Trove(depositCollaterals, decimals, { 'debt': constants_1.YUSD_LIQUIDATION_RESERVE.add(applyFee(borrowingRate, borrowYUSD['debt'])) });
            }
            case "closure":
                if (this.isEmpty) {
                    throw new Error("Can't close empty Trove");
                }
                return exports._emptyTrove;
            case "closureUnleverUp":
                if (this.isEmpty) {
                    throw new Error("Can't close empty Trove");
                }
                return exports._emptyTrove;
            case "adjustment": {
                const { setToZero, params: { depositCollaterals, withdrawCollaterals, borrowYUSD, repayYUSD } } = change;
                const collateralDecrease = withdrawCollaterals !== null && withdrawCollaterals !== void 0 ? withdrawCollaterals : {};
                const collateralIncrease = depositCollaterals !== null && depositCollaterals !== void 0 ? depositCollaterals : {};
                const debtDecrease = repayYUSD !== null && repayYUSD !== void 0 ? repayYUSD : { 'debt': Decimal_1.Decimal.ZERO };
                const debtIncrease = { 'debt': borrowYUSD ? applyFee(borrowingRate, borrowYUSD['debt']) : Decimal_1.Decimal.ZERO };
                return setToZero === "collateral"
                    ? this.setCollateral({}).addDebt(debtIncrease).subtractDebt(debtDecrease)
                    : setToZero === "debt"
                        ? this.setDebt({ 'debt': Decimal_1.Decimal.ZERO })
                            .addCollateral(collateralIncrease)
                            .subtractCollateral(collateralDecrease)
                        : this.add(new Trove(collateralIncrease, this.decimals, debtIncrease)).subtract(new Trove(collateralDecrease, this.decimals, debtDecrease));
            }
            // TODO
            case "addCollLeverUp": {
                const { params: { depositCollaterals, depositCollateralsLeverages, depositCollateralsMaxSlippages, borrowYUSD } } = change;
                const collateralLeveragesIncrease = depositCollateralsLeverages !== null && depositCollateralsLeverages !== void 0 ? depositCollateralsLeverages : {};
                const collateralIncrease = depositCollaterals !== null && depositCollaterals !== void 0 ? depositCollaterals : {};
                const debtIncrease = { 'debt': borrowYUSD ? applyFee(borrowingRate, borrowYUSD['debt']) : Decimal_1.Decimal.ZERO };
                return this.add(new Trove(collateralIncrease, this.decimals, debtIncrease));
            }
            //TODO
            case "withdrawCollUnleverUp": {
                const { params: { withdrawCollaterals, withdrawCollateralsMaxSlippages, repayYUSD } } = change;
                const collateralDecrease = withdrawCollaterals !== null && withdrawCollaterals !== void 0 ? withdrawCollaterals : {};
                const debtDecrease = repayYUSD !== null && repayYUSD !== void 0 ? repayYUSD : { 'debt': Decimal_1.Decimal.ZERO };
                return this.subtract(new Trove(collateralDecrease, this.decimals, debtDecrease));
            }
        }
    }
    /**
     * Calculate the result of an {@link TransactableLiquity.openTrove | openTrove()} transaction.
     *
     * @param params - Parameters of the transaction.
     * @param borrowingRate - Borrowing rate to use when calculating the Trove's debt.
     */
    static create(params, borrowingRate) {
        return exports._emptyTrove.apply(troveCreation(exports._normalizeTroveCreation(params)), borrowingRate);
    }
    /**
     * Calculate the parameters of an {@link TransactableLiquity.openTrove | openTrove()} transaction
     * that will result in the given Trove.
     *
     * @param that - The Trove to recreate.
     * @param borrowingRate - Current borrowing rate.
     */
    static recreate(that, borrowingRate) {
        const change = exports._emptyTrove.whatChanged(that, borrowingRate);
        assert_1.default((change === null || change === void 0 ? void 0 : change.type) === "creation");
        return change.params;
    }
    /**
     * Calculate the result of an {@link TransactableLiquity.adjustTrove | adjustTrove()} transaction
     * on this Trove.
     *
     * @param params - Parameters of the transaction.
     * @param borrowingRate - Borrowing rate to use when adding to the Trove's debt.
     */
    adjust(params, borrowingRate) {
        return this.apply(troveAdjustment(exports._normalizeTroveAdjustment(params)), borrowingRate);
    }
    /**
     * Calculate the parameters of an {@link TransactableLiquity.adjustTrove | adjustTrove()}
     * transaction that will change this Trove into the given Trove.
     *
     * @param that - The desired result of the transaction.
     * @param borrowingRate - Current borrowing rate.
     */
    adjustTo(that, borrowingRate) {
        const change = this.whatChanged(that, borrowingRate);
        assert_1.default((change === null || change === void 0 ? void 0 : change.type) === "adjustment");
        return change.params;
    }
}
exports.Trove = Trove;
/** @internal */
exports._emptyTrove = new Trove();
/**
 * A Trove that is associated with a single owner.
 *
 * @remarks
 * The SDK uses the base {@link Trove} class as a generic container of collateral and debt, for
 * example to represent the {@link ReadableLiquity.getTotal | total collateral and debt} locked up
 * in the protocol.
 *
 * The `UserTrove` class extends `Trove` with extra information that's only available for Troves
 * that are associated with a single owner (such as the owner's address, or the Trove's status).
 *
 * @public
 */
class UserTrove extends Trove {
    /** @internal */
    constructor(ownerAddress, status, collaterals, decimals, debt) {
        super(collaterals, decimals, debt);
        this.ownerAddress = ownerAddress;
        this.status = status;
    }
    equals(that) {
        return (super.equals(that) && this.ownerAddress === that.ownerAddress && this.status === that.status);
    }
    /** @internal */
    toString() {
        return (`{ ownerAddress: "${this.ownerAddress}"` +
            `, collateral: ${this.collaterals}` +
            `, debt: ${this.debt}` +
            `, status: "${this.status}" }`);
    }
}
exports.UserTrove = UserTrove;
/**
 * A Trove in its state after the last direct modification.
 *
 * @remarks
 * The Trove may have received collateral and debt shares from liquidations since then.
 * Use {@link TroveWithPendingRedistribution.applyRedistribution | applyRedistribution()} to
 * calculate the Trove's most up-to-date state.
 *
 * @public
 */
class TroveWithPendingRedistribution extends UserTrove {
    /** @internal */
    constructor(ownerAddress, status, collaterals, decimals, debt, stake = {}, snapshotOfTotalRedistributed = exports._emptyTrove) {
        super(ownerAddress, status, collaterals, decimals, debt);
        this.stake = stake;
        this.snapshotOfTotalRedistributed = snapshotOfTotalRedistributed;
    }
    applyRedistribution(totalRedistributed) {
        // console.log('totalRedistributed', totalRedistributed)
        // console.log('snapshotOfTotalRedistributed', this.snapshotOfTotalRedistributed) 
        // console.log('stake', this.stake)
        // const afterRedistribution = this.add(
        //   totalRedistributed.subtract(this.snapshotOfTotalRedistributed).multiply(this.stake)
        // );
        // temporary fix
        return new UserTrove(this.ownerAddress, this.status, this.collaterals, this.decimals, this.debt);
        // return new UserTrove(
        //   this.ownerAddress,
        //   this.status,
        //   {'avax': Decimal.ZERO},
        //   {'debt': Decimal.ZERO}
        // );
    }
    equals(that) {
        return (super.equals(that) &&
            JSON.stringify(this.stake) == JSON.stringify(that.stake) &&
            this.snapshotOfTotalRedistributed.equals(that.snapshotOfTotalRedistributed));
    }
}
exports.TroveWithPendingRedistribution = TroveWithPendingRedistribution;
//# sourceMappingURL=Trove.js.map